// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"82":"9c0e6057","350":"674f9cf1","397":"00981f59","582":"4dced5dd","614":"e6228c6f","772":"50b4c7ca","985":"da65dfec"}[chunkId] + ".css";
};